export default __webpack_public_path__ + "video/trailer_combat_simple.mp4";